
(()=>{'use strict';
const CFG=window.PB_SHOPIFY||{};
const onShopify=!!(window.Shopify&&window.Shopify.shop)||document.documentElement.hasAttribute('data-shopify');
const q=(s,r=document)=>r.querySelector(s),all=(s,r=document)=>[...r.querySelectorAll(s)];

function say(message,detail){
 let el=q('.pb-cart-note');
 if(!el){el=document.createElement('div');el.className='pb-cart-note';el.setAttribute('role','status');document.body.append(el);}
 el.innerHTML='<p>'+message+'</p>'+(detail?'<pre>'+detail.replace(/[<&]/g,c=>c==='<'?'&lt;':'&amp;')+'</pre>':'')
  +'<button type="button" class="pb-cart-note__x" aria-label="Dismiss">&times;</button>';
 el.classList.add('is-on');
 el.querySelector('.pb-cart-note__x').onclick=()=>el.classList.remove('is-on');
 clearTimeout(say.t);if(!detail)say.t=setTimeout(()=>el.classList.remove('is-on'),6000);
}


async function addToCart(item,label){
 const payload={items:[item]};
 if(!onShopify){say('Preview only — this is the line Shopify would receive.',JSON.stringify(payload,null,2));return false;}
 const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
 if(!res.ok){const err=await res.json().catch(()=>({}));throw new Error(err.description||err.message||'Shopify could not add this to the cart.');}
 const data=await res.json();
 refreshTheme(data);
 say((label||'Item')+' added to your cart. <a href="/cart">View cart &rarr;</a>');
 return true;
}


function refreshTheme(data){
 for(const name of ['cart:refresh','cart:build','cart:updated'])document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:data}));
 document.dispatchEvent(new CustomEvent('pbht:cart',{detail:Object.assign({__fromLayer:true},data)}));
 if(window.Shopify&&typeof window.Shopify.onCartUpdate==='function'){try{window.Shopify.onCartUpdate(data);}catch(e){}}
 const drawer=CFG.cartDrawerSelector&&q(CFG.cartDrawerSelector);
 if(drawer){if(typeof drawer.open==='function')drawer.open();else drawer.classList.add('is-open','active');}
}

document.addEventListener('pbht:cart',e=>{if(e.detail&&e.detail.__fromLayer)return;
 for(const name of ['cart:refresh','cart:build','cart:updated'])document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:e.detail}));},false);


function gate(form,variantId,what){
 const button=q('[type=submit]',form),note=q('[data-pb-gate]',form);
 const ready=Number.isFinite(variantId)&&variantId>0;
 q('[name=id]',form).value=ready?variantId:'';
 if(button)button.disabled=!ready;
 if(note){note.hidden=ready;note.textContent=ready?'':'Connect the Shopify variant ID for '+what+' in shopify-ids.js to enable checkout.';}
 return ready;
}


function hotTubs(){
 const panel=q('[data-pb-order]');if(!panel||!window.PB_HT?.models)return;
 const form=q('form',panel),models=window.PB_HT.models;
 let model=models.find(m=>m.code==='743L-230')||models[0];
 const name=q('[data-pb-order-name]',panel),facts=q('[data-pb-order-facts]',panel);

 const show=()=>{
  name.textContent=model.name+' · '+model.variant;
  facts.textContent=[model.seatsLabel,model.jets+' jets',model.dims.w+'" × '+model.dims.l+'"',model.voltage+' V'].join(' · ');
  const priced=window.PB_PRICING?.hotTubs?.[model.code];
  let priceEl=q('.lx-order__price',panel);
  if(priced){
   if(!priceEl){priceEl=document.createElement('p');priceEl.className='lx-order__price';name.parentElement.after(priceEl);}
   priceEl.textContent=priced.display+' CAD';
  }else if(priceEl)priceEl.remove();
  q('[name="properties[Model]"]',form).value=model.name+' '+model.variant;
  all('[data-pb-order-model]',panel).forEach(b=>b.setAttribute('aria-checked',String(b.dataset.pbOrderModel===model.code)));
  gate(form,CFG.hotTubs?.[model.code]?.variantId,model.name+' '+model.variant);
 };
 all('[data-pb-order-model]',panel).forEach(b=>b.addEventListener('click',()=>{model=models.find(m=>m.code===b.dataset.pbOrderModel)||model;show();
  const view=q('[data-model-view="'+model.code+'"]');if(view&&view.getAttribute('aria-pressed')!=='true')view.click();}));
 
 document.addEventListener('click',e=>{const t=e.target.closest('[data-model-view]');if(!t)return;
  const m=models.find(x=>x.code===t.dataset.modelView);if(m){model=m;show();}});

 form.addEventListener('submit',async e=>{
  const id=q('[name=id]',form).value;
  if(!onShopify||!id){e.preventDefault();
   await addToCart({id:Number(id)||null,quantity:1,properties:properties(form)},model.name);return;}
  
  e.preventDefault();
  const button=q('[type=submit]',form),was=button.textContent;button.disabled=true;button.textContent='Adding…';
  try{await addToCart({id:Number(id),quantity:1,properties:properties(form)},model.name+' '+model.variant);}
  catch(err){say(err.message);}
  finally{button.disabled=false;button.textContent=was;}
 });
 show();
}
function properties(form){
 const out={};
 for(const el of all('[name^="properties["]',form)){
  if((el.type==='radio'||el.type==='checkbox')&&!el.checked)continue;
  const key=el.name.slice(11,-1);if(el.value)out[key]=el.value;
 }
 return out;
}


function covers(){
 const review=q('#cover-review');if(!review)return;
 const summary=q('#cover-summary');
 const form=document.createElement('form');
 form.className='pb-cover-cart';form.method='post';form.action='/cart/add';form.setAttribute('data-pb-cover-cart','');
 form.innerHTML='<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">'
  +'<div data-pb-cover-props hidden></div>'
  +'<button class="lx-button" type="submit">Add this cover to my cart</button>'
  +'<p class="pb-cart-gate" data-pb-gate hidden></p>'
  +'<p class="pb-cart-fine">Made to your measurements. Pool Busters checks the specification and confirms pricing before the cover is built.</p>';
 review.append(form);
 const ready=()=>gate(form,CFG.cover?.variantId,'the custom spa cover');
 ready();

 
 const readSpec=()=>{
  const skip=/^(Name|Email|Phone|Municipality)$/i,props={};
  for(const line of (summary.textContent||'').split('\n')){
   const i=line.indexOf(': ');if(i<1)continue;
   const key=line.slice(0,i).trim(),value=line.slice(i+2).trim();
   if(!value||value==='Not provided'||skip.test(key))continue;
   props[key]=value;
  }
  const spa=q('.lx-materials__models [aria-checked="true"]');
  if(spa)props['Spa model']=spa.dataset.modelLabel||spa.textContent.replace(/\s+/g,' ').trim();
  return props;
 };
 const sync=()=>{
  const box=q('[data-pb-cover-props]',form);box.replaceChildren();
  for(const [k,v] of Object.entries(readSpec())){
   const input=document.createElement('input');input.type='hidden';input.name='properties['+k+']';input.value=v;box.append(input);
  }
 };
 new MutationObserver(sync).observe(summary,{childList:true,characterData:true,subtree:true});
 sync();

 form.addEventListener('submit',async e=>{
  e.preventDefault();sync();
  const id=q('[name=id]',form).value;
  const button=q('[type=submit]',form),was=button.textContent;
  button.disabled=true;button.textContent='Adding…';
  try{await addToCart({id:Number(id)||null,quantity:1,properties:properties(form)},'Custom spa cover');}
  catch(err){say(err.message);}
  finally{button.disabled=!ready();button.textContent=was;}
 });
}

hotTubs();covers();
// If the IDs file is edited or injected late, re-check the gates once the page settles.
addEventListener('load',()=>{document.dispatchEvent(new CustomEvent('pb:recheck'));});
})();
